import { TORUS_KNOT } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyGeometryProperty, applyProperties } from './base';

export class TorusKnot extends BaseObject {
  constructor() {
    super(
      new THREE.TorusKnotGeometry(
        TORUS_KNOT.RADIUS,
        TORUS_KNOT.TUBE,
        TORUS_KNOT.TUBULAR_SEGMENTS,
        TORUS_KNOT.RADIAL_SEGMENTS
      ),
      new THREE.MeshStandardMaterial({ color: TORUS_KNOT.COLOR })
    );

    this.radius = TORUS_KNOT.RADIUS;
    this.tube = TORUS_KNOT.TUBE;
    this.radialSegments = TORUS_KNOT.RADIAL_SEGMENTS;
    this.tubularSegments = TORUS_KNOT.TUBULAR_SEGMENTS;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.TorusKnotGeometry(this.radius, this.tube, this.tubularSegments, this.radialSegments);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      const needsUpdate =
        applyGeometryProperty(this, properties.radius, 'radius', TORUS_KNOT.MIN_RADIUS) |
        applyGeometryProperty(this, properties.tube, 'tube', TORUS_KNOT.MIN_TUBE) |
        applyGeometryProperty(this, properties.radialSegments, 'radialSegments', TORUS_KNOT.MIN_RADIAL_SEGMENTS) |
        applyGeometryProperty(this, properties.tubularSegments, 'tubularSegments', TORUS_KNOT.MIN_TUBULAR_SEGMENTS);

      if (needsUpdate) this.updateGeometry();
    };
  }
}
